import { i18n } from "@/setup/i18n-setup";
import { getModel } from "../models/model";
import { PropSelectGroup } from "./prop-select-group";
import { PropSelectItem } from "./prop-select-item";

// eslint-disable-next-line max-lines-per-function
export function getBankConditionPropSelectGroup():PropSelectGroup{
	let result = new PropSelectGroup("", "", "Bank");
	let saleModel = getModel("Bank");
	let fields = saleModel.getFilterFields();

	for (let field of fields){
		let parts = field.path.split(".");
		if (parts.length == 1){
			result.items.push(new PropSelectItem(i18n.t(`models.friendlyNames.Bank.${parts[0]}`), field.path, field.field.type));
			continue;
		}
		/*
		let fieldName = parts.pop();
		let model = getModel(field.modelName);
		let f = model.getField(fieldName || "") || field;
		let group = getGroup(parts);
		group.items.push(new PropSelectItem(i18n.t(`models.friendlyNames.${field.modelName}.${fieldName}`), field.path, f.field.type));
		*/
	}

	return result;
}